import styled from "styled-components";
import { colors } from "../../../../utils";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 16px;
`;

export const Title = styled.div`
  font-family: 'DM Sans', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: #0F0F0F;
  margin-bottom: 5px;
`;

export const InputWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px 10px 16px;
  width: 100%;
  max-width: 400px;
  height: 44px;
  background: #FFFFFF;
  border: 1px solid #CED4DA;
  border-radius: 8px;
`;

export const InputField = styled.input`
  flex: 1;
  border: none;
  outline: none;
  font-family: 'DM Sans', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #565556;
  
  &::placeholder {
    color: #9A999A;
  }
  
  &:disabled {
    background: transparent;
    color: #9A999A;
  }
`;

export const ClearButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 24px;
  height: 24px;
  margin: 0 4px;
`;

export const AppliedCode = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px 10px 16px;
  width: 100%;
  max-width: 400px;
  height: 44px;
  background: #F6F7F9;
  border: 1px solid #CED4DA;
  border-radius: 8px;
  font-family: 'DM Sans', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: ${colors.PrimaryPurple};
`;

export const ApplyButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  padding: 0 12px;
  background-color: ${colors.PrimaryPurple};
  color: white;
  border: none;
  border-radius: 6px;
  font-family: 'DM Sans', sans-serif;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: ${colors.HoverPurple || "#8a4fe3"};
  }
  
  &:disabled {
    background-color: #D3D3D3;
    cursor: not-allowed;
  }
`;

export const ErrorMessage = styled.div`
  margin-top: 6px;
  color: #d32f2f;
  font-family: 'DM Sans', sans-serif;
  font-size: 12px;
  line-height: 1.2;
`; 